// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__20SCY","signatureBlock":"Footer_signatureBlock__1Ajt_","signature":"Footer_signature__3J0c9"};